import styled from 'styled-components';

export const ComponentContainer = styled.div`
  height: 100%;
  width: 100%;
`;
